"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.systemDataExportSuccess = exports.systemDataExportReset = exports.systemDataExportError = exports.surveyDownload = exports.exportDownloadUserActivity = exports.exportDownloadUser = exports.exportDownloadRecord = exports.exportDownloadFromArchive = exports.exportDownloadChangeLog = void 0;
var _systemDataExport = require("./systemDataExport.constant");
// common success
var systemDataExportSuccess = function systemDataExportSuccess(actionType, data) {
  return {
    type: _systemDataExport.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};
// common error
exports.systemDataExportSuccess = systemDataExportSuccess;
var systemDataExportError = function systemDataExportError(actionType, error) {
  return {
    type: _systemDataExport.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};
/**
 * download record
 * @param payload
 * @returns api response
 * @description this function used to download sheet.
 */
exports.systemDataExportError = systemDataExportError;
var exportDownloadRecord = function exportDownloadRecord(data) {
  return {
    type: _systemDataExport.actionTypes.RECORDS_EXPORT_DOWNLOAD,
    payload: data
  };
};
/**
 * download user activity
 * @param payload
 * @returns api response
 * @description this function used to download user activity.
 */
exports.exportDownloadRecord = exportDownloadRecord;
var exportDownloadUser = function exportDownloadUser(data) {
  return {
    type: _systemDataExport.actionTypes.USERS_EXPORT_DOWNLOAD,
    payload: data
  };
};
/**
 * download user acitivity export
 * @param payload
 * @returns api response
 * @description this function used to download user activity export.
 */
exports.exportDownloadUser = exportDownloadUser;
var exportDownloadUserActivity = function exportDownloadUserActivity(data) {
  return {
    type: _systemDataExport.actionTypes.USERS_ACTIVITY_EXPORT_DOWNLOAD,
    payload: data
  };
};
/**
 * download change log
 * @param payload
 * @returns api response
 * @description this function used to download change log.
 */
exports.exportDownloadUserActivity = exportDownloadUserActivity;
var exportDownloadChangeLog = function exportDownloadChangeLog(data) {
  return {
    type: _systemDataExport.actionTypes.CHANGE_LOG_EXPORT_DOWNLOAD,
    payload: data
  };
};
/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.exportDownloadChangeLog = exportDownloadChangeLog;
var systemDataExportReset = function systemDataExportReset() {
  return {
    type: _systemDataExport.actionTypes.RESET
  };
};
/**
 * export from archive modal
 * @param payload
 * @returns api response
 * @description this function used to download from archive.
 */
exports.systemDataExportReset = systemDataExportReset;
var exportDownloadFromArchive = function exportDownloadFromArchive(data) {
  return {
    type: _systemDataExport.actionTypes.EXPORT_DOWNLOAD_FROM_ARCHIVE,
    payload: data
  };
};

/**
 * Download
 * @param payload
 * @returns api response
 * @description this function used to Download.
 */
exports.exportDownloadFromArchive = exportDownloadFromArchive;
var surveyDownload = function surveyDownload(data) {
  return {
    type: _systemDataExport.actionTypes.DOWNLOAD,
    payload: data
  };
};
exports.surveyDownload = surveyDownload;